module.exports = __webpack_public_path__ + "img/clue4.fed096ec.png";